import { ChangeEvent } from "react";
import { Input } from "components/common/Input/Input";
import { useSize } from "./useSize";
import { Translate } from "components/common/Translate/Translate";

interface SizeProps {
    handleWidthChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleHeightChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Size = ({ handleWidthChange, handleHeightChange }: SizeProps) => {
    const { height, width } = useSize();

    return (
        <div className="flex max-w-full items-end gap-2">
            <div className="flex flex-col min-w-0 gap-2">
                <div className="capitalize" data-testid="width-input-label">
                    <Translate keyName="width" />
                </div>
                <Input
                    type="number"
                    value={Math.round(width)}
                    min={0}
                    onChange={handleWidthChange}
                    data-testid="width-input"
                />
            </div>
            <div className="flex flex-col min-w-0 gap-2">
                <div className="capitalize" data-testid="height-input-label">
                    <Translate keyName="height" />
                </div>
                <Input
                    type="number"
                    value={Math.round(height)}
                    min={0}
                    onChange={handleHeightChange}
                    data-testid="height-input"
                />
            </div>
        </div>
    );
};
